import { isDateValidAndPast } from 'src/components/oneCorp/features/MealCredit/utils/isDateValidAndPast';
import { calculateCurrentEndDateRangeAvailability } from 'src/components/oneCorp/features/MealCredit/utils/calculateCurrentEndDateRangeAvailability';
import { getAvailableDateRangeText } from 'src/components/oneCorp/features/MealCredit/utils/getAvailableDateRangeText';

export interface DateRangeSectionProps {
  isMealCreditAvailable: boolean;
  refreshPeriodMonthsCount: number;
  monthAvailability: {
    isMonthAvailableOnSpecificDay: boolean;
    isMonthAvailableWithinDateRange: boolean;
    monthAvailableDaysCount: number;
  };
  dates: {
    startDate: Date;
    monthAvailableTo: Date;
    currentCycleStartDate: Date;
    currentCycleEndDate: Date;
    expirationDate: Date;
  };
}

export function buildDateRangeSection(
  props: DateRangeSectionProps
): string | null {
  const {
    isMealCreditAvailable,
    refreshPeriodMonthsCount,
    monthAvailability: {
      isMonthAvailableOnSpecificDay,
      isMonthAvailableWithinDateRange,
      monthAvailableDaysCount,
    },
    dates: {
      startDate,
      monthAvailableTo,
      currentCycleStartDate,
      currentCycleEndDate,
      expirationDate,
    },
  } = props;
  const isExpirationDateInvalid = isDateValidAndPast(expirationDate);
  const isMealCreditUnavailable = !isMealCreditAvailable;
  const isRangeUnavailable =
    !isMonthAvailableOnSpecificDay && !isMonthAvailableWithinDateRange;

  if (
    isExpirationDateInvalid ||
    isMealCreditUnavailable ||
    isRangeUnavailable
  ) {
    return null;
  }

  // needed to ensure overnight credits - monthly, specific day, shows only a single day
  // not an interval between start day and next day
  // example: Aug 31 5PM to Sept 1 10AM interval should show only Aug 31, not Aug 31 - Sept 1
  const shouldShowSingleDay = isMonthAvailableOnSpecificDay;

  const endDateRangeInsideMonth = shouldShowSingleDay
    ? currentCycleStartDate
    : calculateCurrentEndDateRangeAvailability({
        firstInstanceStartDate: startDate,
        firstInstanceEndDate: monthAvailableTo,
        currentCycleStartDate,
        currentCycleEndDate,
      });

  const isMultiMonthsLengthBudget = refreshPeriodMonthsCount > 1;

  return getAvailableDateRangeText({
    currentCycleStartDate,
    endDateRangeInsideMonth,
    isMultiMonthsLengthBudget,
    monthAvailableDaysCount,
  });
}
